import { getPublishRulesErvkKnmReasonTypes } from '../selectors/publishRulesSelectors';
import { PublishRulesRenderFunc } from '../types/PublishRulesRenderFunc';

export const renderReasonTypes: PublishRulesRenderFunc = (item, state) => {
  const { newValue, oldValue } = item;

  const ervkKnmReasonTypes = (state && getPublishRulesErvkKnmReasonTypes(state)) || [];

  const renderedOldOption = ervkKnmReasonTypes.find(type => type.id === oldValue);
  const renderedNewOption = ervkKnmReasonTypes.find(type => type.id === newValue);

  return {
    renderedOldValue: renderedOldOption?.name || '',
    renderedNewValue: renderedNewOption?.name || '',
  };
};
